import BuscadorTablas from 'components/Buscador/BuscadorTabla'
import TarjetaContenido from 'components/TarjetaContenido/TarjetaContenido'
import { useFormik } from 'formik'
import { useDimension } from 'hooks/useDimension'
import { useToggle } from 'hooks/useToggle'
import React, { useState } from 'react'
import { FaPencilAlt, FaSave, FaTrash } from 'react-icons/fa'
import {
  Button,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Table,
} from 'reactstrap'
import uuid from 'uuid/v4'
import * as yup from 'yup'
import PaginaPorDefecto from './Default'

const initialValues = {
  identificador: '',
  nombre: '',
  descripcion: '',
}

const dimensionSchema = yup.object().shape({
  nombre: yup.string().required('Este campo es requerido'),
  descripcion: yup.string().required('Este campo es requerido'),
})

export default function Dimension() {
  const { open, onToggle } = useToggle()
  const [dimensionEdit, setDimensionEdit] = useState(null)
  const [buscar, setBuscar] = useState('')
  const {
    obtenerDimensiones,
    handleEliminarDimension,
    handleActualizarDimension,
    handleCrearDimension,
    handleBuscarDimension,
  } = useDimension(onToggle)
  const { data: dimensiones } = obtenerDimensiones(buscar)

  const { handleChange, values, handleSubmit, errors } = useFormik({
    enableReinitialize: true,
    validationSchema: dimensionSchema,
    initialValues: {
      ...initialValues,
      ...dimensionEdit,
    },
    onSubmit: async (values, acciones) => {
      if (dimensionEdit) {
        handleActualizarDimension({ values, acciones, id: dimensionEdit.id })
      } else {
        handleCrearDimension(values, acciones)
      }
    },
  })

  const onClosedModal = () => {
    setDimensionEdit(null)
  }

  return (
    <PaginaPorDefecto titulo='Dimensión'>
      <Modal
        isOpen={open}
        toggle={onToggle}
        size='lg'
        unmountOnClose
        onClosed={onClosedModal}
      >
        <ModalHeader toggle={onToggle}>
          {dimensionEdit ? 'Editar' : 'Crear'} Dimensión
        </ModalHeader>
        <ModalBody>
          <form className='form-horizontal col-xs-' onSubmit={handleSubmit}>
            <FormGroup>
              <Label>Identificador</Label>
              <Input
                type='text'
                name='identificador'
                value={values.identificador}
                onChange={handleChange}
                placeholder='Ingrese identificador'
                invalid={!!errors.identificador}
              />
              <div className='invalid-feedback'>{errors.nombre}</div>
            </FormGroup>

            <FormGroup>
              <Label>Nombre</Label>
              <Input
                type='text'
                name='nombre'
                value={values.nombre}
                onChange={handleChange}
                placeholder='Ingrese nombre'
                invalid={!!errors.nombre}
              />
              <div className='invalid-feedback'>{errors.nombre}</div>
            </FormGroup>

            <FormGroup>
              <Label>Descripción</Label>
              <Input
                type='textarea'
                name='descripcion'
                value={values.descripcion}
                onChange={handleChange}
                placeholder='Ingrese descripción'
                invalid={!!errors.descripcion}
              />
              <div className='invalid-feedback'>{errors.descripcion}</div>
            </FormGroup>

            <div className='form-group'>
              <label
                className='col-md-12 control-label'
                htmlFor='singlebutton'
              ></label>
              <div className='col-md-12'>
                <Button className='mb-3' color='primary' type='submit'>
                  {dimensionEdit ? 'Editar' : 'Guardar'}
                </Button>
              </div>
            </div>
          </form>
        </ModalBody>
      </Modal>

      <TarjetaContenido
        titulo='Listar Dimensión'
        component={
          <Button outline color='primary' onClick={onToggle}>
            <FaSave />
          </Button>
        }
      >
        <BuscadorTablas
          valor={buscar}
          onChange={setBuscar}
          onBuscar={handleBuscarDimension}
        />
        {dimensiones ? (
          <Table responsive>
            <thead>
              <tr>
                <th>#</th>
                <th>Identificador</th>
                <th>Nombre</th>
                <th>Descripción</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {dimensiones.results.map((dimension, index) => (
                <tr key={uuid()}>
                  <th scope='row'>{index + 1}</th>
                  <td>{dimension.identificador}</td>
                  <td>{dimension.nombre}</td>
                  <td>{dimension.descripcion}</td>
                  <td className='d-flex'>
                    <Button
                      outline
                      color='primary'
                      size='sm'
                      className='mr-1'
                      onClick={() => {
                        setDimensionEdit(dimension)
                        onToggle()
                      }}
                    >
                      <FaPencilAlt />
                    </Button>{' '}
                    <Button
                      outline
                      color='danger'
                      size='sm'
                      onClick={() => handleEliminarDimension(dimension)}
                    >
                      <FaTrash />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          <div>Loading...</div>
        )}
      </TarjetaContenido>
    </PaginaPorDefecto>
  )
}
